import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";
export async function getPackageListByCurrencyIdAndIsMonthly(
    currencyID,
    IsMonthly
) {
    return fetch(
        Config.apiUrl +
        "SystemPackage/GetPackageListByCurrencyIdAndIsMonthly?CurrencyId=" +
        currencyID +
        "&IsMonthly=" +
        IsMonthly,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

// export async function getPackageListByCurrencyIdAndIsMonthly(
//     currencyID,
//     IsMonthly,
//     isweb
// ) {
//     return fetch(
//         Config.apiUrl +
//         "SystemPackage/GetPackageListByCurrencyIdAndIsMonthlyAndISWeb?CurrencyId=" +
//         currencyID +
//         "&IsMonthly=" +
//         IsMonthly + "&isweb=" + isweb,

//         {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//         }
//     )
//         .then(handleResponse)
//         .catch(handleError);
// }

export async function getPackageCurrencyList(
) {
    return fetch(
        Config.apiUrl +
        "GenericListing/GetPackageCurrencyList",
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}


export async function checkUserbyEmail(email, isWeb) {
    return fetch(
        Config.apiUrl + "UserCompany/checkUserbyEmail?email=" + email + "&IsWeb=" + isWeb,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}
